<p>app-reinhried works!</p>
<div id="wrapper">
  <header>CCXXXIX</header>
   
    <div class="example-container">
        <mat-form-field>
          <mat-label>Enter your password</mat-label>
          <input matInput placeholder="Password" [type]="hide ? 'password' : 'text'" [(ngModel)]="myPassword" (input)="onPasswordInput()">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      
        <!--h5>{{myPassword}}</h5-->
      </div>
<div *ngIf="hidecode">
  <div class="row w-100 justify-content-center align-items-center">

   		  
    <div class="col-3 mb-6 mt-6 ml-6 mb-lg-6">
      <iframe src='https://geoportal.bayern.de/bayernatlas/embed.html?lang=de&topic=ba&catalogNodes=11&bgLayer=atkis&E=611000.13&N=5294010.84&zoom=14&layers=luftbild_parz' width='600' height='450' frameborder='0' style='border:0'></iframe>
</div>
  


  <div class="col-3 mb-6 mt-6 ml-6 mb-lg-6">
  <iframe src='https://geoportal.bayern.de/bayernatlas/embed.html?lang=de&topic=ba&catalogNodes=11&bgLayer=atkis&E=611231.19&N=5293980.22&zoom=13&layers=luftbild_parz' width='600' height='450' frameborder='0' style='border:0'></iframe>
</div>  
  <div class="col-3 mb-6 mt-6 ml-6 mb-lg-6">
  <iframe src='https://geoportal.bayern.de/bayernatlas/embed.html?lang=de&topic=ba&catalogNodes=11&bgLayer=atkis&E=611792.88&N=5295190.42&zoom=13&layers=luftbild_parz' width='600' height='450' frameborder='0' style='border:0'></iframe>
</div> 
  <div class="col-3 mb-6 mt-6 ml-6 mb-lg-6">
  <iframe src='https://geoportal.bayern.de/bayernatlas/embed.html?lang=de&topic=ba&catalogNodes=11&bgLayer=atkis&E=612027.51&N=5295260.05&zoom=13&layers=luftbild_parz' width='600' height='450' frameborder='0' style='border:0'></iframe>
</div> 
  <div class="col-3 mb-6 mt-6 ml-6 mb-lg-6">
  <iframe src='https://geoportal.bayern.de/bayernatlas/embed.html?lang=de&topic=ba&catalogNodes=11&bgLayer=atkis&E=611762.16&N=5295750.88&zoom=13&layers=luftbild_parz' width='600' height='450' frameborder='0' style='border:0'></iframe>
</div>
  <div class="col-3 mb-6 mt-6 ml-6 mb-lg-6"> 
  <iframe src='https://geoportal.bayern.de/bayernatlas/embed.html?lang=de&topic=ba&catalogNodes=11&bgLayer=atkis&E=611798.60&N=5293454.38&zoom=13&layers=luftbild_parz' width='600' height='450' frameborder='0' style='border:0'></iframe>
</div>  
  </div>
  <p>Quelle: BayernAtlas</p>
  <ng-container>
    <li><a href="./assets/Grundstuecksbegradigung.pdf" target="_blank">Grotz Grundstücksbegradigung</a></li>
  </ng-container>
   

</div>
</div>
